import React, { useState, useEffect } from "react"
import "./Header.scss"

function Header() {
  const [active, setActive] = useState(1)
  
  const scrollToSection = (elementId) => {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      const element = document.getElementById(elementId)
      if (element) {
        window.scrollTo({
          top: element.offsetTop - 80,
          behavior: "smooth",
        })
      }
    }
  }
  
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return

    const sections = [
      { id: "project-synopsis", index: 1 },
      { id: "location", index: 2 },
      { id: "project-specifications", index: 3 },
      { id: "gallery", index: 4 },
      { id: "project-status", index: 5 },
    ]

    const observerOptions = {
      root: null,
      rootMargin: "-100px 0px -60% 0px",
      threshold: 0,
    }

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const section = sections.find((s) => s.id === entry.target.id)
          if (section) {
            setActive(section.index)
          }
        }
      })
    }

    const observer = new IntersectionObserver(observerCallback, observerOptions)

    sections.forEach((section) => {
      const element = document.getElementById(section.id)
      if (element) {
        observer.observe(element)
      }
    })

    return () => {
      sections.forEach((section) => {
        const element = document.getElementById(section.id)
        if (element) {
          observer.unobserve(element)
        }
      })
    }
  }, [])
  
  return (
    <div className="header-the-edge">
      <span
        className={`menu-item ${active === 1 ? "active" : ""}`}
        onClick={() => {
          setActive(1)
          scrollToSection("project-synopsis")
        }}
      >
        Project Synopsis
      </span>
 
      <span
        className={`menu-item ${active === 3 ? "active" : ""}`}
        onClick={() => {
          setActive(3)
          scrollToSection("project-specifications")
        }}
      >
        Project Specifications
      </span>
      <span
        className={`menu-item ${active === 4 ? "active" : ""}`}
        onClick={() => {
          setActive(4)
          scrollToSection("gallery")
        }}
      >
        Gallery
      </span>
      <span
        className={`menu-item ${active === 5 ? "active" : ""}`}
        onClick={() => {
          setActive(5)
          scrollToSection("project-status")
        }}
      >
        Project Status
      </span>
           <span
        className={`menu-item ${active === 2 ? "active" : ""}`}
        onClick={() => {
          setActive(2)
          scrollToSection("location")
        }}
      >
        Location
      </span>
    </div>
  )
}

export default Header
